// extracted by mini-css-extract-plugin
module.exports = {"about":"About_about__31F2I","aboutImg":"About_aboutImg__29zeo"};